// extracted by mini-css-extract-plugin
module.exports = {"SortIndicator":"sort-indicator_SortIndicator__3PCC4"};